import { AuthProvider } from './../../providers/auth/auth';
import { FoserviceProvider } from './../../providers/foservice/foservice';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, Platform } from 'ionic-angular';
import { DatePicker } from '@ionic-native/date-picker';
import { GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the FoInventoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-fo-inventory',
  templateUrl: 'fo-inventory.html',
})
export class FoInventoryPage {

  dash: {};
  loading: Loading;
  name = '';
  username = '';
  serverlocation = '';
  token = '';
  userid = '';
  dateOne: Date;
  dateTwo: Date;
  dateThree: Date;
  dateFour: Date;
  today : any;
  isBrowser: boolean;

  constructor(public platform: Platform, public navCtrl: NavController, public navParams: NavParams, private auth: AuthProvider,
    private foservice: FoserviceProvider, public datepicker: DatePicker, private loadingCtrl: LoadingController, private global: GlobalProvider) {

    this.isBrowser = (!document.URL.startsWith('http') || document.URL.startsWith('http://localhost:8100'));
    this.isBrowser = true;

    if(this.isBrowser) {
      if(platform.is('android')) {
        this.isBrowser = false;
      }
      if(platform.is('ios')) {
        this.isBrowser = false;
      }
    }
    let info = this.auth.getUserInfo();
    this.name = info.name;
    this.username = info.username;
    this.serverlocation = info.serverlocation;
    this.userid = info.userid;
    this.token = info.token;
    let mstart = new Date();
    this.today = (new Date(mstart)).toISOString();
    if(!this.isBrowser) {
      console.log('Not is browser');
      //this.today= mstart.getDate()+'/'+(Number(mstart.getMonth())+Number(1))+'/'+mstart.getFullYear()
      this.today= mstart.getFullYear()+'-'+mstart.getMonth()+'-'+mstart.getDate();
    } else {
      console.log("is Browser");
    }
    //this.today = new Date();
    //console.log("Today: "+this.today);

    this.loadData();
  }

  public loadData() {
    //this.showLoading()
    this.showLoading();

    this.foservice.loadRoomInventory(this.userid, this.token, this.serverlocation, this.today, this.global.ICNO)
    .then(data => {
      if(data) {
        this.dash = data;
        this.dateOne = new Date(data[0]['activeDate']);
        this.dateTwo = new Date();
        this.dateThree = new Date();
        this.dateFour = new Date();
        this.dateTwo.setDate(this.dateOne.getDate() + 1);
        this.dateThree.setDate(this.dateOne.getDate() + 2);
        this.dateFour.setDate(this.dateOne.getDate() + 3);
        //this.today = this.dateOne.getDate()+'/'+(Number(this.dateOne.getMonth())+Number(1))+'/'+this.dateOne.getFullYear();
        this.today = (new Date(this.dateOne.getFullYear()+'-'+(Number(this.dateOne.getMonth())+Number(1))+'-'+this.dateOne.getDate())).toISOString();
        console.log('Date One '+this.dateOne.getDate());
        console.log('Date Today:'+this.today);

      }
      this.loading.dismiss();
    });

  }
  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadData();
    setTimeout(() => {
      console.log('Async operation has ended');
      refresher.complete();
    }, 2000);
  }
  itemTapped(event, detail) {
    // this.navCtrl.push(DashboardDetailPage, {
    //   detail: detail
    // });
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad FOInventoryPage');
  }

  openDatepicker(){
    this.datepicker.show({
      date: new Date(this.today),
      mode: 'date',
      is24Hour : true,
      androidTheme: this.datepicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => {
        this.today= date}, //date.getFullYear()+'-'+(Number(date.getMonth())+Number(1))+'-'+(Number(date.getDate())+Number(1))},
      err => console.log('Error occurred while getting date: ', err)
    );
  }
  changeDate() {
    this.loadData();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fo-inventory/fo-inventory.ts